<template lang="pug">
     v-layout#layout-login
        v-flex(xs12='' sm5='' offset-sm4='')
            v-card.card-login.pa-5
                v-card-title(primary-title='')
                    div.flex.s12
                        h3.headline.mb-0 {{isNew ? 'Crear Nueva' : 'Reestablecer'}} Contraseña
                        div
                            v-flex(xs12='')
                                v-form.pt-3
                                    RUTInput(
                                      v-model='rut'
                                      label='RUT'
                                      required
                                      ref="rut"
                                      :rules="[rules.required, rules.rut]"
                                      :color="colors.primary")
                                    v-layout
                                      v-flex.xs9
                                        v-text-field(
                                          v-if="!generated"
                                          type="password"
                                          v-model='password'
                                          label='Contraseña' 
                                          @input="$v.password.$touch()"
                                          @blur="$v.password.$touch()" 
                                          :error-messages="passwordError"
                                          required=''
                                          :color="colors.primary")
                                        .d-flex(
                                          v-else
                                          style="align-items: center;"
                                          )
                                          b.title(style="flex-grow: 1;") Contraseña: {{generated}}
                                          v-btn(
                                            large
                                            outline
                                            @click="clearGenerated"
                                            ) Limpiar
                                      v-flex.xs3.pl-3
                                        v-btn.primary(
                                          large
                                          @click="generatePassword"
                                          block) Generar
                                    v-text-field.mb-3(
                                      type="password"
                                      v-if="!generated"
                                      v-model='password_repeat' 
                                      label='Repita su contraseña'
                                      @input="$v.password_repeat.$touch()" 
                                      @blur="$v.password_repeat.$touch()"
                                      :error-messages="passwordRepeatError" 
                                      required='' :color="colors.primary")
                                    v-btn.ml-0(type="button" color='success' v-on:click="resetPassword") {{isNew ? 'Crear' : 'Reestablecer'}} Contraseña 
                                    router-link.pb-3(tag='span' to='/login')
                                        a Iniciar Sesión
</template>

<script>
import { mapActions } from 'vuex'
import colors from '@/mixins/Colors'
import { validationMixin } from 'vuelidate'
import RUTUtils from '@/mixins/RUTUtils'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import RUTInput from '@/components/RUTInput/RUTInput.vue'
import { times, random } from 'lodash'
// Custom validate functions
const rutValido = function(rut) {
    return this.mixValidateRUT(rut)
}

export default {
    name: '',
    components: { RUTInput },
    data: () => {
        return {
            rut: '',
            password: '',
            password_repeat: '',
            bRejectResetPassByServer: false,
            generated: false,
        }
    },
    mixins: [validationMixin, RUTUtils],
    validations: {
        rut: {
            required,
            rutValido,
            bCorrectResetPassByServer(value) {
                if (this.bRejectResetPassByServer) return false

                return true
            },
        },
        password: {
            required,
            minLength: minLength(6),
        },
        password_repeat: {
            required,
            sameAsPassword: sameAs('password'),
            minLength: minLength(6),
        },
    },
    watch: {
        rut: function(newVal) {
            this.mixRUTInputHandler(newVal)
        },
    },
    computed: {
        rutError() {
            const errors = []
            if (!this.$v.rut.$dirty) return errors
            !this.$v.rut.required && errors.push('El RUT es obligatorio')
            !this.$v.rut.rutValido && errors.push('RUT incorrecto')
            !this.$v.rut.bCorrectResetPassByServer &&
                errors.push('RUT o Token Incorrecto')
            this.bRejectResetPassByServer = false // if reject by server, show error message only 1 time
            return errors
        },
        rules() {
            let dv = this.mixDV
            return {
                required: v => !!v || 'Campo Obligatorio',
                rut(v) {
                    if (v.length < 3) return 'RUT no válido'
                    if (!v.includes('-')) return 'Sin puntos, con guión'
                    let rut = v
                        .split('.')
                        .join('')
                        .split('-')
                    if (dv(rut[0]) !== parseInt(rut[1])) return 'RUT no válido'
                    return true
                },
            }
        },
        passwordError() {
            const errors = []
            if (!this.$v.password.$dirty) return errors
            !this.$v.password.required &&
                errors.push('La contraseña es obligatoria')
            !this.$v.password.minLength &&
                errors.push('La contraseña debe contener mínimo 6 caracteres')
            return errors
        },
        passwordRepeatError() {
            const errors = []
            if (!this.$v.password_repeat.$dirty) return errors
            !this.$v.password_repeat.required &&
                errors.push('La contraseña es obligatoria')
            !this.$v.password_repeat.sameAsPassword &&
                errors.push('Las contraseñas no coinciden')
            !this.$v.password_repeat.minLength &&
                errors.push('La contraseña debe contener mínimo 6 caracteres')
            return errors
        },
        isNew() {
            return !!this.$route.query.new
        },
    },
    methods: {
        ...mapActions('AuthModule', {
            resetPasswordRequestAction: 'resetPasswordRequestAction',
        }),
        generatePassword() {
            let passwd = times(8, () => random(35).toString(36)).join('')
            this.password = passwd
            this.password_repeat = passwd
            this.generated = passwd
        },
        clearGenerated() {
            this.password = ''
            this.password_repeat = ''
            this.generated = null
        },
        resetPassword: function() {
            this.$v.$touch()
            if (!this.$v.$error) {
                let rut = this.mixRUTFormatter(this.rut)
                let password = this.password
                let password_repeat = this.password_repeat

                this.resetPasswordRequestAction({
                    rut,
                    password,
                    password_repeat,
                    token: this.$route.params.token,
                })
                    .then(() => {
                        this.$router.push('/')
                    })
                    .catch(err => {
                        console.log(err)
                        // Show error below input email
                        this.bRejectResetPassByServer = true
                        this.rutError
                    })
            } // end if
        }, // end function
    },
}
</script>

<style lang="scss" scoped>
#layout-login {
    /* Bg Image */
    background-image: url('../../assets/bg-agro.jpg');
    background-size: 100% 100%;
}

#layout-login::before {
    content: '';
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    width: 100%;
    height: 100%;
}

.card-login {
    margin-top: 60px;
    background-color: rgba(255, 255, 255, 0.85) !important;
}

a {
    color: darkcyan;
}
</style>
